/* Maison Lamora — installation page: specs from the catalogue, tabs, room viewer. */
(function () {
  function init() {
    var root = document.querySelector('[data-installation]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var D = window.LAMORA_DATA, L = window.LAMORA;
    var inst = (D.installations || []).find(function (i) { return i.id === root.dataset.id || i.handle === root.dataset.id; });
    var comp = D.compositions.reduce(function (m, c) { m[c[0]] = c[1]; return m; }, {});
    var rooms = Object.keys(D.rooms).reduce(function (m, k) { m[k] = D.rooms[k][0]; return m; }, { other: 'Bespoke setting' });
    var tones = D.tones || {};

    if (inst) {
      var eyebrow = root.querySelector('[data-inst-eyebrow]');
      if (eyebrow) eyebrow.textContent = comp[inst.composition] + ' · ' + (rooms[inst.room] || inst.room);
      var specs = root.querySelector('[data-inst-specs]');
      if (specs) {
        specs.innerHTML = [
          ['Composition', comp[inst.composition] || inst.composition],
          ['Setting', rooms[inst.room] || inst.room],
          ['Glass tone', (tones[inst.tone] || [inst.tone])[0]],
          ['Pieces', inst.pieces + ' hand-blown pieces'],
          ['Dimensions', inst.width + ' W × ' + inst.depth + ' D × ' + inst.height + ' H cm'],
          ['Lead time', '7 to 14 days, made to order']
        ].map(function (r) { return '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd>'; }).join('');
      }
      var q = root.querySelector('[data-inst-quote]');
      if (q) q.href = L.pages.quote + '?product=' + encodeURIComponent(inst.name) + '&variant=' + encodeURIComponent(comp[inst.composition] + ' / ' + (tones[inst.tone] || [''])[0] + ' / ' + inst.pieces + ' pieces');
      var btn = root.querySelector('[data-enquiry-toggle]');
      if (btn) btn.dataset.detail = comp[inst.composition] + ' · ' + inst.pieces + ' pieces · ' + inst.width + '×' + inst.depth + '×' + inst.height + ' cm';
    }

    // composer used for the room viewer preview of this installation
    var PRESET = { 'wing|honey': ['feather1', ['dual']], 'wing|blacktint': ['feather002', ['fea-010', 'fea-013']], 'wing|transparent': ['feather1', ['transparent']], 'wing|tint': ['feather002', ['fea-009']], 'blownleaf|gold': ['frozen', ['frz-002', 'frz-001']], 'blownleaf|transparent': ['frozen', ['frz-001', 'frz-005']], 'blownleaf|blue': ['frozen', ['frz-008', 'frz-003']], 'leaf|honey': ['leaf', ['lvs-002', 'lvs-001']], 'bloom|transparent': ['flower', ['flw-001']] };
    var composer = null;
    function makeComposer() {
      if (composer || !inst || !window.LamoraComposer) return composer;
      var p = PRESET[inst.element + '|' + inst.tone] || ['feather1', ['dual']];
      var edef = D.elements.find(function (e) { return e.id === p[0]; }) || D.elements[0];
      var tdefs = p[1].map(function (t) { return edef.tones.find(function (x) { return x.id === t; }); }).filter(Boolean);
      if (!tdefs.length) tdefs = [edef.tones[0]];
      var cv = document.createElement('canvas');
      composer = new window.LamoraComposer(cv, {
        design: inst.composition, pieces: inst.pieces, width: inst.width, depth: inst.depth, height: inst.height,
        dropStart: inst.composition === 'cascadespiral' || inst.composition === 'waterfall' ? 4 : 18,
        dropEnd: inst.composition === 'ring' ? 55 : 95,
        sprites: tdefs.map(function (t) { return t.sku; }), colors: tdefs.map(function (t) { return t.color; }),
        yaw: -0.5, pitch: 0.3, spots: true
      });
      // show which glass goes into it
      var wrap = root.querySelector('[data-inst-pieces]');
      if (wrap) {
        wrap.hidden = false;
        wrap.querySelector('.tiles').innerHTML = tdefs.map(function (t) {
          return '<a class="tile" href="' + L.pages.configure + '?piece=' + encodeURIComponent(t.sku) + '"><span class="tile__img" style="--swatch:' + t.color + '"><img alt="" loading="lazy" src="' + L.pieceImage(t.sku, 360) + '" onerror="this.remove()"></span><span class="tile__label">' + t.label + '</span><span class="tile__meta">' + t.sku + '</span></a>';
        }).join('');
      }
      return composer;
    }

    var viewer = null;
    root.querySelectorAll('[data-inst-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.dataset.instTab;
        root.querySelectorAll('[data-inst-tab]').forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
        root.querySelectorAll('[data-inst-panel]').forEach(function (p) { p.hidden = p.dataset.instPanel !== name; });
        if (name === 'model' && L.loadModelViewer) L.loadModelViewer();
        if (name === 'room') {
          var c = makeComposer();
          if (!viewer && window.LamoraRoomViewer && c) {
            var list = [];
            try { list = JSON.parse(root.querySelector('[data-inst-rooms-json]').textContent).filter(Boolean); } catch (e) {}
            viewer = new window.LamoraRoomViewer(root.querySelector('[data-room-viewer]'), {
              rooms: list,
              getChandelier: function () {
                var ratio = Math.max(0.5, Math.min(2.2, (inst.height + 40) / Math.max(inst.width, 60)));
                var snap = c.snapshot(1400, Math.round(1400 * ratio));
                return { canvas: snap.canvas, pxPerCm: snap.pxPerCm, widthCm: inst.width };
              }
            });
          } else if (viewer) viewer.draw();
        }
      });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
